import React, { useMemo } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';

import appConfig from '@nerdwallet/app-config';

import { AnalyticsContext, AnalyticsContextProps } from './AnalyticsContext';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export const AnalyticsProvider = ({
  children,
}: AnalyticsProviderProps): JSX.Element => {
  const writeKey = appConfig?.SEGMENT?.WRITE_KEY ?? '';

  const value: AnalyticsContextProps = useMemo(
    () => ({
      analytics: writeKey
        ? AnalyticsBrowser.load(
            {
              writeKey: appConfig?.SEGMENT?.WRITE_KEY,
              cdnURL: appConfig?.SEGMENT?.CDN_URL,
            },
            {
              cookie: {
                domain: appConfig?.SEGMENT?.DOMAIN,
                maxage: appConfig?.SEGMENT?.MAX_AGE,
                secure: appConfig?.SEGMENT?.SECURE,
              },
              integrations: {
                'Segment.io': {
                  apiHost: appConfig?.SEGMENT?.API_HOST,
                  protocol: appConfig?.SEGMENT?.PROTOCOL,
                },
              },
            }
          )
        : null,
    }),
    [writeKey]
  );

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;
